function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFDFC",
  d: "M0 0h3656v1145H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2167.793 432.94a3.26 3.26 0 01-3.246-3.196 3.227 3.227 0 01.916-2.313 3.236 3.236 0 012.281-.987h.052a3.26 3.26 0 013.246 3.196 3.253 3.253 0 01-3.197 3.3h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2167.793 426.876c1.53 0 2.79 1.244 2.814 2.773a2.817 2.817 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.814-2.774 2.817 2.817 0 012.77-2.86h.047m0-.863h-.06a3.68 3.68 0 00.054 7.36h.06a3.68 3.68 0 003.624-3.737 3.677 3.677 0 00-3.678-3.623z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2688.793 432.94a3.26 3.26 0 01-3.246-3.196 3.227 3.227 0 01.916-2.313 3.236 3.236 0 012.281-.987h.052a3.26 3.26 0 013.246 3.196 3.253 3.253 0 01-3.197 3.3h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2688.793 426.876c1.53 0 2.79 1.244 2.814 2.773a2.817 2.817 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.814-2.774 2.817 2.817 0 012.77-2.86h.047m0-.863h-.06a3.68 3.68 0 00.054 7.36h.06a3.68 3.68 0 003.624-3.737 3.677 3.677 0 00-3.678-3.623z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3198.793 432.94a3.26 3.26 0 01-3.246-3.196 3.227 3.227 0 01.916-2.313 3.236 3.236 0 012.281-.987h.052a3.26 3.26 0 013.246 3.196 3.253 3.253 0 01-3.197 3.3h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3198.793 426.876c1.53 0 2.79 1.244 2.814 2.773a2.817 2.817 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.814-2.774 2.817 2.817 0 012.77-2.86h.047m0-.863h-.06a3.68 3.68 0 00.054 7.36h.06a3.68 3.68 0 003.624-3.737 3.677 3.677 0 00-3.678-3.623z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2395.793 655.94a3.26 3.26 0 01-3.246-3.196 3.227 3.227 0 01.916-2.313 3.236 3.236 0 012.281-.987h.052a3.26 3.26 0 013.246 3.196 3.253 3.253 0 01-3.197 3.3h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2395.793 649.876c1.53 0 2.79 1.244 2.814 2.773a2.817 2.817 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.814-2.774 2.817 2.817 0 012.77-2.86h.047m0-.863h-.06a3.68 3.68 0 00.054 7.36h.06a3.68 3.68 0 003.624-3.737 3.677 3.677 0 00-3.678-3.623z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2916.793 655.94a3.26 3.26 0 01-3.246-3.196 3.227 3.227 0 01.916-2.313 3.236 3.236 0 012.281-.987h.052a3.26 3.26 0 013.246 3.196 3.253 3.253 0 01-3.197 3.3h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2916.793 649.876c1.53 0 2.79 1.244 2.814 2.773a2.817 2.817 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.814-2.774 2.817 2.817 0 012.77-2.86h.047m0-.863h-.06a3.68 3.68 0 00.054 7.36h.06a3.68 3.68 0 003.624-3.737 3.677 3.677 0 00-3.678-3.623z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3446.793 655.94a3.26 3.26 0 01-3.246-3.196 3.227 3.227 0 01.916-2.313 3.236 3.236 0 012.281-.987h.052a3.26 3.26 0 013.246 3.196 3.253 3.253 0 01-3.197 3.3h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3446.793 649.876c1.53 0 2.79 1.244 2.814 2.773a2.817 2.817 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.814-2.774 2.817 2.817 0 012.77-2.86h.047m0-.863h-.06a3.68 3.68 0 00.054 7.36h.06a3.68 3.68 0 003.624-3.737 3.677 3.677 0 00-3.678-3.623z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2078.684 727.093a3.26 3.26 0 01-3.246-3.196 3.253 3.253 0 013.197-3.3h.051a3.26 3.26 0 013.246 3.196 3.227 3.227 0 01-.916 2.313 3.236 3.236 0 01-2.28.987h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2078.686 721.028c1.53 0 2.791 1.244 2.814 2.774a2.817 2.817 0 01-2.77 2.86h-.046a2.826 2.826 0 01-2.814-2.774 2.81 2.81 0 012.77-2.86h.046m0-.864h-.06a3.68 3.68 0 00.055 7.361h.06a3.68 3.68 0 00-.055-7.36z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2262.684 510.093a3.26 3.26 0 01-3.246-3.196 3.253 3.253 0 013.197-3.3h.051a3.26 3.26 0 013.246 3.196 3.227 3.227 0 01-.916 2.313 3.236 3.236 0 01-2.28.987h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2262.686 504.028c1.53 0 2.791 1.244 2.814 2.774a2.817 2.817 0 01-2.77 2.86h-.046a2.826 2.826 0 01-2.814-2.774 2.81 2.81 0 012.77-2.86h.046m0-.864h-.06a3.68 3.68 0 00.055 7.361h.06a3.68 3.68 0 00-.055-7.36z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2783.684 510.093a3.26 3.26 0 01-3.246-3.196 3.253 3.253 0 013.197-3.3h.051a3.26 3.26 0 013.246 3.196 3.227 3.227 0 01-.916 2.313 3.236 3.236 0 01-2.28.987h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2783.686 504.028c1.53 0 2.791 1.244 2.814 2.774a2.817 2.817 0 01-2.77 2.86h-.046a2.826 2.826 0 01-2.814-2.774 2.81 2.81 0 012.77-2.86h.046m0-.864h-.06a3.68 3.68 0 00.055 7.361h.06a3.68 3.68 0 00-.055-7.36z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3313.684 510.093a3.26 3.26 0 01-3.246-3.196 3.253 3.253 0 013.197-3.3h.051a3.26 3.26 0 013.246 3.196 3.227 3.227 0 01-.916 2.313 3.236 3.236 0 01-2.28.987h-.052z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3313.686 504.028c1.53 0 2.791 1.244 2.814 2.774a2.817 2.817 0 01-2.77 2.86h-.046a2.826 2.826 0 01-2.814-2.774 2.81 2.81 0 012.77-2.86h.046m0-.864h-.06a3.68 3.68 0 00.055 7.361h.06a3.68 3.68 0 00-.055-7.36z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1860.925 700.082a3.26 3.26 0 01-3.245-3.197 3.253 3.253 0 013.196-3.3h.052a3.26 3.26 0 013.246 3.196 3.227 3.227 0 01-.916 2.313 3.236 3.236 0 01-2.28.988h-.053z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1860.928 694.017c1.53 0 2.791 1.244 2.814 2.773a2.81 2.81 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.813-2.774 2.817 2.817 0 012.77-2.86h.046m0-.863h-.06a3.68 3.68 0 00.055 7.36h.06a3.68 3.68 0 00-.055-7.36z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1352.925 719.082a3.26 3.26 0 01-3.245-3.197 3.253 3.253 0 013.196-3.3h.052a3.26 3.26 0 013.246 3.196 3.227 3.227 0 01-.916 2.313 3.236 3.236 0 01-2.28.988h-.053z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1352.928 713.017c1.53 0 2.791 1.244 2.814 2.773a2.81 2.81 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.813-2.774 2.817 2.817 0 012.77-2.86h.046m0-.863h-.06a3.68 3.68 0 00.055 7.36h.06a3.68 3.68 0 00-.055-7.36z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M502.925 719.082a3.26 3.26 0 01-3.245-3.197 3.253 3.253 0 013.196-3.3h.052a3.26 3.26 0 013.246 3.196 3.227 3.227 0 01-.916 2.313 3.236 3.236 0 01-2.28.988h-.053z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502.928 713.017c1.53 0 2.791 1.244 2.814 2.773a2.81 2.81 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.813-2.774 2.817 2.817 0 012.77-2.86h.046m0-.863h-.06a3.68 3.68 0 00.055 7.36h.06a3.68 3.68 0 00-.055-7.36z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M585.925 496.082a3.26 3.26 0 01-3.245-3.197 3.253 3.253 0 013.196-3.3h.052a3.26 3.26 0 013.246 3.196 3.227 3.227 0 01-.916 2.313 3.236 3.236 0 01-2.28.988h-.053z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585.928 490.017c1.53 0 2.791 1.244 2.814 2.773a2.81 2.81 0 01-2.77 2.86h-.047a2.826 2.826 0 01-2.813-2.774 2.817 2.817 0 012.77-2.86h.046m0-.863h-.06a3.68 3.68 0 00.055 7.36h.06a3.68 3.68 0 00-.055-7.36z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1506.946 489.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1506.946 483.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1001.946 489.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1001.946 483.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1261.946 651.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1261.946 645.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M411.946 651.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411.946 645.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M756.946 651.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756.946 645.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1360.946 473.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1360.946 467.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M510.946 473.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510.946 467.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M905.946 496.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M905.946 490.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M1740.65 736.842l4.302-3.01 3.01 4.301-4.3 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1744.838 734.431l2.515 3.592-3.592 2.514-2.514-3.591 3.591-2.515m.21-1.203l-5.008 3.504 3.505 5.009 5.009-3.505-3.505-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M1968.652 501.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1972.838 499.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2294.652 691.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2298.838 689.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2815.652 691.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2819.838 689.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3345.652 691.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3349.838 689.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2568.652 492.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2572.838 490.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2510.652 690.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2514.838 688.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3031.652 690.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3035.838 688.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3031.652 473.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3035.838 471.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3561.652 690.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3565.838 688.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3617.652 478.826l4.302-3.01 3.01 4.3-4.301 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3621.838 476.426l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.214-1.204l-5.009 3.505 3.505 5.008 5.008-3.505-3.504-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M1556.628 640.83l4.301-3.01 3.01 4.3-4.3 3.011z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1560.815 638.423l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.213-1.204l-5.008 3.505 3.505 5.008 5.008-3.505-3.505-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M1208.628 478.83l4.301-3.01 3.01 4.3-4.3 3.011z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1212.815 476.423l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.213-1.204l-5.008 3.505 3.505 5.008 5.008-3.505-3.505-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M358.628 478.83l4.301-3.01 3.01 4.3-4.3 3.011z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362.815 476.423l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.213-1.204l-5.008 3.505 3.505 5.008 5.008-3.505-3.505-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M752.628 467.83l4.301-3.01 3.01 4.3-4.3 3.011z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756.815 465.423l2.515 3.591-3.592 2.514-2.514-3.591 3.591-2.514m.213-1.204l-5.008 3.505 3.505 5.008 5.008-3.505-3.505-5.008z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M1770.654 413.994l4.037-3.355 3.356 4.037-4.038 3.356z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1774.628 411.259l2.802 3.372-3.372 2.802-2.802-3.372 3.372-2.802m.112-1.216l-4.7 3.908 3.908 4.7 4.7-3.908-3.908-4.7z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#170C2C",
  strokeWidth: 0.864,
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M1705.5 481.5l9.384 5.5M1574 731l-9 7M1140 673l-9 7M290 673l-9 7M635 673l-9 7M1424 654l-9 7M919 654l-9 7M1284.228 439.071l4.404-6.108M434.228 439.071l4.404-6.108M836.228 433.071l4.404-6.108M1089 468l-9-7M239 468l-9-7M644 421l-9-7M1912 427l8 8M2028 627l5 10M2078.365 473.163l-5.365 9.442M2475.048 458.884l-5.365 9.442M2367 448l-10 5M2888 448l-10 5M3418 448l-10 5M2232 660l-10 5M2753 660l-10 5M3283 660l-10 5M1979 740l2-11M1573 428l-6-9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1849.986 507c.491 15.524-11.866 28.501-27.603 28.986-15.736.485-28.891-11.705-29.383-27.23",
  fill: "#F7C9D6",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1947 667.198l-29.653 24.587-96.96-102.83L1723.325 692 1694 667.048l97.23-105.307a39.692 39.692 0 0128.627-12.737 39.714 39.714 0 0129.69 12.737L1947 667.198z",
  fill: "#F0CBD6",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1738.183 676.754c.897-3.29 1.43-6.627.935-10.022-.55-3.757-2.092-7.233-3.537-10.717-1.583-3.817-2.763-7.686-1.93-11.83.73-3.62 2.559-7.38 5.339-9.908 1.32-1.203 2.954-2.12 4.778-2.256 1.961-.146 3.893.511 5.857.267 2.99-.37 4.458-2.807 5.216-5.439.883-3.07 1.253-6.302 3.654-8.693 3.111-3.1 7.348-1.346 9.292 2.09 3.616 6.385 2.38 14.45 2.937 21.43.038.468.813.657.897.12.51-3.182.41-6.526.245-9.735-.178-3.424-.563-6.853-1.71-10.11-1.137-3.218-3.48-6.461-7.18-6.906-3.118-.376-5.664 1.664-7.16 4.184-1.715 2.89-1.663 6.303-3.181 9.225-2.188 4.21-7.308 1.254-10.941 2.48-3.351 1.13-5.75 4.086-7.317 7.094-1.815 3.484-2.78 7.416-2.217 11.328.69 4.82 3.391 9.078 4.866 13.67 1.468 4.578 1.363 8.86.486 13.538-.081.437.554.623.67.19z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1745.946 668.612c-.16-5.04.372-10.442 1.952-15.235.842-2.555 2.708-6.2 5.849-4.162 1.116.725 1.616 2 2.085 3.203.433 1.106.905 2.191 1.316 3.308.198.533.947.33.842-.234-.483-2.555-.933-5.877-3.177-7.51-2.913-2.12-5.887-.574-7.32 2.398-1.27 2.63-1.769 5.625-2.105 8.507-.378 3.23-.525 6.482-.236 9.727.047.505.81.525.794-.002zM1715.16 645.655c2.373 1.53 3.902 3.736 5.14 6.27 1.404 2.869 2.453 5.878 2.483 9.123.059 6.121-3.023 11.783-7.125 16.037-.475.493.253 1.24.743.761 4.614-4.513 7.873-10.574 7.58-17.268-.255-5.836-3.43-12.552-8.473-15.527-.384-.228-.717.365-.347.604zM1750.263 606.056c3.57.28 7.083-.814 10.2-2.47 2.233-1.19 4.371-2.559 6.737-3.484a25.058 25.058 0 017.896-1.696c3.956-.192 7.428.845 10.521 3.323.937.751 1.802 1.59 2.61 2.476.316.346.681.951 1.156 1.089.313.091.623-.066.796-.324.302-.45-.141-1.069-.342-1.464-.417-.811-1.61-.1-1.219.71 2.084 4.338.27 8.88-.632 13.254-.09.43.543.765.756.318 2.09-4.355 3.276-9.755 1.095-14.282-.406.237-.814.472-1.219.71.368.714.046.487.345.043.264-.109.532-.215.796-.324.457.132.012-.12-.215-.372-.282-.31-.561-.619-.854-.92a22.893 22.893 0 00-2.938-2.561c-3.102-2.272-6.562-3.22-10.397-3.066-5.142.206-9.563 2.052-13.967 4.57-2.265 1.298-4.54 2.498-7.092 3.134a45.64 45.64 0 01-4.107.814c-.31.049-.204.499.074.522zM1764.194 591.202c3.894 1.503 8.273.716 11.95-.976 4.506-2.074 8.63-5.22 12.065-8.777 3.525-3.65 6.356-7.917 8.693-12.406 2.4-4.606 4.695-9.584 6.085-14.6.105-.379-.449-.626-.644-.271-2.322 4.282-3.967 8.925-6.193 13.266-2.263 4.407-4.906 8.642-8.259 12.31-3.274 3.577-7.172 6.682-11.48 8.925-2.27 1.18-4.769 2.147-7.35 2.272-1.602.08-3.204-.125-4.792-.297-.34-.038-.35.449-.075.554zM1855.69 568.134c-4.1 5.355-7.582 13.206-4.53 19.821 1.257 2.722 3.452 5.051 6.15 6.383 3.248 1.604 6.901 1.36 10.321 2.315 6.757 1.883 8.926 9.427 8.778 15.69-.076 3.206-.508 6.615.615 9.7 1.04 2.86 3.386 4.74 6.298 5.497 7.57 1.97 14.968-2.69 19.593-8.312.267-.322-.151-.763-.468-.467-4.756 4.456-10.987 8.895-17.888 7.668-3.502-.624-5.981-2.84-6.664-6.357-.598-3.08-.023-6.246-.127-9.35-.169-4.973-1.798-10.462-5.964-13.546-2.645-1.959-5.86-2.229-9.013-2.678-3.208-.459-6.054-1.486-8.313-3.897-6.12-6.528-2.488-15.652 1.754-22.145.224-.351-.305-.633-.543-.322z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1885.336 600.137c-.97 2.186-.986 5.143-1.134 7.514-.118 1.885-.564 4.568.431 6.283 2.218 3.836 7.297-3.782 8.315-5.575.216-.384-.29-.786-.596-.473-1.18 1.197-2.3 2.454-3.511 3.621-.46.444-1.148 1.427-1.747 1.635l-1.37-.062a3.341 3.341 0 01-.218-.703c-.092-.429-.095-.867-.112-1.302a55.351 55.351 0 01.057-5.137c.102-1.85.55-3.83.374-5.667-.027-.233-.37-.402-.49-.134zM1874.105 646.01c3.957-2.4 7.854-4.874 12.263-6.41 4.012-1.398 8.987-2.21 12.167 1.276 1.417 1.553 2.273 3.51 3.47 5.217.994 1.416 2.214 2.623 3.682 3.556 3.021 1.92 6.765 2.551 10.306 2.297 4.672-.33 9.003-2.174 12.76-4.865.559-.4.079-1.267-.548-.93-3.897 2.097-7.91 4.077-12.414 4.351-3.856.234-8.002-.63-10.91-3.284-2.888-2.634-3.813-6.864-7.294-8.947-3.359-2.01-7.64-1.321-11.147-.097-4.484 1.564-9.442 3.964-12.425 7.72-.043.065.014.162.09.117zM1889.332 661.371c3.79-2.453 8.89-2.958 12.74-.334 3.275 2.232 5.096 6.59 9.645 6.42 4.078-.15 7.355-3.69 11.445-3.522 6.816.279 1.34 8.734-.94 11.155-3.488 3.7-7.906 6.284-12.04 9.173-.43.302-.064.901.408.695 4.51-1.983 8.762-4.863 12.225-8.371 1.611-1.634 3.088-3.482 4.064-5.569.932-1.994 1.777-4.67.387-6.656-2.788-3.985-8.456-.921-11.715.515-2.354 1.034-4.833 1.677-7.122.116-2.065-1.407-3.408-3.633-5.47-5.055-4.128-2.848-10.382-2.615-13.898 1.085-.172.174.05.49.271.348z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#000",
  fillRule: "nonzero",
  transform: "rotate(-40.494 1932.563 679.536)",
  cx: 1932.563,
  cy: 679.536,
  rx: 19.256,
  ry: 5.933
}), /*#__PURE__*/React.createElement("path", {
  d: "M1932 676.494c7.514 14.176 14.03 20.625 19.547 19.348 8.275-1.916 39-33.792 36.284-38.17-1.812-2.918-14.562 3.661-38.251 19.738l-7.141-8.434",
  fill: "#F9D26F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 1.152,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1952 680l4-10M1957 678l4-10M1963 676l4-10"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#000",
  fillRule: "nonzero",
  transform: "rotate(-49.506 1709.188 679.4)",
  cx: 1709.188,
  cy: 679.4,
  rx: 5.933,
  ry: 19.256
}), /*#__PURE__*/React.createElement("path", {
  d: "M1711 677.717c-4.985 10.855-11.037 16.283-18.158 16.283-10.68 0-36.079-28.603-33.684-33.193 1.597-3.06 12.825 2.577 33.684 16.91l7.089-8.656 11.069 8.656z",
  fill: "#F9D26F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 1.152,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1690 680l-4-10M1684 678l-4-10M1678 674l-4-10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1837.995 487.641c.2 7.73-5.905 14.155-13.635 14.354-6.833.177-12.65-4.575-14.042-11.02-.182-.846-.29-1.72-.313-2.616-.2-7.727 5.905-14.155 13.635-14.354a13.958 13.958 0 0110.312 4.148 13.988 13.988 0 014.043 9.488z",
  fill: "#F9D26F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1834 478.113c-3.572 7.43-11.149 12.654-20.044 12.88a23.524 23.524 0 01-3.637-.192 13.8 13.8 0 01-.314-2.59c-.2-7.647 5.917-14.01 13.662-14.207a14.094 14.094 0 0110.333 4.109z",
  fill: "#000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#000",
  fillRule: "nonzero",
  cx: 1823.5,
  cy: 468.5,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#000",
  fillRule: "nonzero",
  cx: 1815.5,
  cy: 450.5,
  r: 15.5
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#000",
  fillRule: "nonzero",
  transform: "rotate(-5.814 1827.657 494.263)",
  cx: 1827.657,
  cy: 494.263,
  rx: 1.411,
  ry: 2.212
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#000",
  fillRule: "nonzero",
  transform: "rotate(-5.814 1823.006 494.891)",
  cx: 1823.006,
  cy: 494.891,
  rx: 1.411,
  ry: 2.212
}), /*#__PURE__*/React.createElement("path", {
  d: "M1828 501s-1.932-.262-2-2",
  stroke: "#000",
  strokeWidth: 1.152
}), /*#__PURE__*/React.createElement("path", {
  d: "M1823.478 668c-52.982 0-58.323-47.364-36.21-67.4 14.755-13.376 31.458-15.222 12.774-34.785-18.378-19.244-8.87-48.815 23.387-48.815 32.338 0 41.762 29.57 23.384 48.815-18.683 19.563-1.98 21.409 12.778 34.784 22.113 20.037 13.121 67.401-36.113 67.401z",
  fill: "#489F9D",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1782 651.175c.794-1.843 2.59-3.142 4.7-3.174 2.88-.047 5.253 2.286 5.3 5.208a5.303 5.303 0 01-2.832 4.791",
  stroke: "#FFF",
  strokeWidth: 0.864
}), /*#__PURE__*/React.createElement("path", {
  d: "M1811.001 645.833c2.26 0 4.13 1.838 4.165 4.102a4.144 4.144 0 01-1.174 2.966 4.133 4.133 0 01-2.927 1.266H1811c-2.26 0-4.13-1.838-4.165-4.102a4.144 4.144 0 011.174-2.966 4.133 4.133 0 012.927-1.266h.066m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10zM1822.004 575.833c2.26 0 4.13 1.838 4.165 4.102a4.171 4.171 0 01-4.101 4.232h-.067c-2.26 0-4.129-1.838-4.165-4.102a4.171 4.171 0 014.102-4.232h.066m-.003-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5.002 5.002 0 004.92-5.08 4.999 4.999 0 00-4.998-4.92zM1832.001 522.833c2.26 0 4.13 1.838 4.165 4.102a4.171 4.171 0 01-4.1 4.232h-.067c-2.26 0-4.13-1.838-4.165-4.102a4.171 4.171 0 014.1-4.232h.067m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10zM1800.001 632.833c2.26 0 4.13 1.838 4.165 4.102a4.144 4.144 0 01-1.174 2.966 4.133 4.133 0 01-2.927 1.266H1800c-2.26 0-4.13-1.838-4.165-4.102a4.144 4.144 0 011.174-2.966 4.133 4.133 0 012.927-1.266h.066m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1774 628.011c3.1-.183 5.781 1.902 5.987 4.66.207 2.76-2.137 5.145-5.237 5.329M1787.215 600c2.088 1.783 2.387 4.981.672 7.148-1.718 2.166-4.8 2.476-6.887.696",
  stroke: "#FFF",
  strokeWidth: 0.864
}), /*#__PURE__*/React.createElement("path", {
  d: "M1821.001 622.833c2.26 0 4.13 1.838 4.165 4.102a4.171 4.171 0 01-4.1 4.232h-.067c-2.26 0-4.13-1.838-4.165-4.102a4.171 4.171 0 014.1-4.232h.067m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5.002 5.002 0 004.92-5.08 5.002 5.002 0 00-4.998-4.92zM1834.001 644.833c2.26 0 4.13 1.838 4.165 4.102a4.144 4.144 0 01-1.174 2.966 4.133 4.133 0 01-2.927 1.266H1834c-2.26 0-4.13-1.838-4.165-4.102a4.144 4.144 0 011.174-2.966 4.133 4.133 0 012.927-1.266h.066m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10zM1850.001 630.833c2.26 0 4.13 1.838 4.165 4.102a4.144 4.144 0 01-1.174 2.966 4.133 4.133 0 01-2.927 1.266H1850c-2.26 0-4.13-1.838-4.165-4.102a4.144 4.144 0 011.174-2.966 4.133 4.133 0 012.927-1.266h.066m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1862.049 651a4.822 4.822 0 01-1.048-2.92c-.047-2.76 2.264-5.035 5.158-5.08.285-.005.567.015.841.05M1823 667c-.044-2.717 2.161-4.956 4.921-5 2.76-.043 5.035 2.127 5.079 4.844",
  stroke: "#FFF",
  strokeWidth: 0.864
}), /*#__PURE__*/React.createElement("path", {
  d: "M1789.004 616.833c2.26 0 4.13 1.838 4.165 4.102a4.144 4.144 0 01-1.174 2.966 4.133 4.133 0 01-2.927 1.266h-.067c-2.26 0-4.129-1.838-4.165-4.102a4.144 4.144 0 011.175-2.966 4.133 4.133 0 012.927-1.266h.066m-.003-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5.002 5.002 0 004.92-5.08 4.997 4.997 0 00-4.998-4.92zM1835.001 609.833c2.26 0 4.13 1.838 4.165 4.102a4.171 4.171 0 01-4.1 4.232h-.067c-2.26 0-4.13-1.838-4.165-4.102a4.171 4.171 0 014.1-4.232h.067m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10zM1808.001 599.833c2.26 0 4.13 1.838 4.165 4.102a4.144 4.144 0 01-1.174 2.966 4.133 4.133 0 01-2.927 1.266H1808c-2.26 0-4.13-1.838-4.165-4.102a4.171 4.171 0 014.1-4.232h.067m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5.002 5.002 0 004.92-5.08 5.002 5.002 0 00-4.998-4.92zM1830.001 591.833c2.26 0 4.13 1.838 4.165 4.102a4.171 4.171 0 01-4.1 4.232h-.067c-2.26 0-4.13-1.838-4.165-4.102a4.144 4.144 0 011.174-2.966 4.133 4.133 0 012.927-1.266h.066m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10zM1803.004 549.833c2.26 0 4.13 1.838 4.165 4.102a4.144 4.144 0 01-1.174 2.966 4.133 4.133 0 01-2.927 1.266h-.067c-2.26 0-4.129-1.838-4.165-4.102a4.171 4.171 0 014.102-4.232h.066m-.003-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5.002 5.002 0 004.92-5.08 4.999 4.999 0 00-4.998-4.92z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1792.25 533c2.62.645 4.24 3.378 3.617 6.1-.62 2.725-3.249 4.409-5.867 3.761",
  stroke: "#FFF",
  strokeWidth: 0.864
}), /*#__PURE__*/React.createElement("path", {
  d: "M1818.001 534.833c2.26 0 4.13 1.838 4.165 4.102a4.144 4.144 0 01-1.174 2.966 4.133 4.133 0 01-2.927 1.266H1818c-2.26 0-4.13-1.838-4.165-4.102a4.171 4.171 0 014.1-4.232h.067m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5.002 5.002 0 004.92-5.08 5.002 5.002 0 00-4.998-4.92zM1829.001 554.833c2.26 0 4.13 1.838 4.165 4.102a4.171 4.171 0 01-4.1 4.232h-.067c-2.26 0-4.13-1.838-4.165-4.102a4.171 4.171 0 014.1-4.232h.067m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1870 621.838c-2.568.7-5.186-.934-5.847-3.65-.661-2.718.882-5.488 3.45-6.188",
  stroke: "#FFF",
  strokeWidth: 0.864
}), /*#__PURE__*/React.createElement("path", {
  d: "M1848.001 601.833c2.26 0 4.13 1.838 4.165 4.102a4.171 4.171 0 01-4.1 4.232h-.067c-2.26 0-4.13-1.838-4.165-4.102a4.171 4.171 0 014.1-4.232h.067m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5.002 5.002 0 004.92-5.08 5.002 5.002 0 00-4.998-4.92z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1809.38 519c1.374 2.656.389 5.954-2.203 7.364-2.589 1.41-5.803.399-7.177-2.26M1855 539.999c-2.699.064-4.936-2.129-4.999-4.895a5.042 5.042 0 011.934-4.104",
  stroke: "#FFF",
  strokeWidth: 0.864
}), /*#__PURE__*/React.createElement("path", {
  d: "M1836.001 539.833c2.26 0 4.13 1.838 4.165 4.102a4.171 4.171 0 01-4.1 4.232h-.067c-2.26 0-4.13-1.838-4.165-4.102a4.171 4.171 0 014.1-4.232h.067m0-.833h-.08a5.002 5.002 0 00-4.92 5.08 4.999 4.999 0 004.998 4.92h.08a5 5 0 00-.078-10z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1849.35 562c-2.427-.355-4.31-2.396-4.35-4.892-.045-2.776 2.207-5.063 5.025-5.107a5.128 5.128 0 013.975 1.776",
  stroke: "#FFF",
  strokeWidth: 0.864
}), /*#__PURE__*/React.createElement("path", {
  d: "M1792.02 513c-9.036 6.055-36.509 35.304-33.838 45.79 2.947 11.567 42.293 29.122 45.822 30.124 3.98 1.128 10.328-9.17 9.982-11.1-.411-2.3-7.377 2.828-7.377 2.828s6.528-11.103 6.304-13.193c-.234-2.214-7.496 8.407-7.496 8.407s2.288-11.031 1.545-12.53c-.861-1.737-5.115 10.012-5.115 10.012L1780.88 556.5l7.155-7.089M1850.053 511c9.347 7.122 37.757 40.222 34.721 50.69-3.347 11.55-38.733 26.324-42.256 27.199-3.969.985-12.307-4.843-11.895-6.772.492-2.302 8.113.432 8.113.432s-9.027-9.917-8.729-12.017c.315-2.222 9.075 6.505 9.075 6.505s-2.729-10.725-1.939-12.208c.914-1.718 5.287 7.753 5.287 7.753l20.028-14.061-6.163-6.732",
  stroke: "#000",
  strokeWidth: 1.152,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F0CBD6",
  fillRule: "nonzero",
  cx: 1963.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#B292D9",
  fillRule: "nonzero",
  cx: 2131.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#B292D9",
  fillRule: "nonzero",
  cx: 2652.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#B292D9",
  fillRule: "nonzero",
  cx: 3162.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F9DC93",
  fillRule: "nonzero",
  cx: 1502.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F9DC93",
  fillRule: "nonzero",
  cx: 997.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F9DC93",
  fillRule: "nonzero",
  cx: 147.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F0CBD6",
  fillRule: "nonzero",
  cx: 1332.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F0CBD6",
  fillRule: "nonzero",
  cx: 482.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F0CBD6",
  fillRule: "nonzero",
  cx: 827.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#608BE4",
  fillRule: "nonzero",
  cx: 1164.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#608BE4",
  fillRule: "nonzero",
  cx: 314.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#608BE4",
  fillRule: "nonzero",
  cx: 659.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#608BE4",
  fillRule: "nonzero",
  cx: 2298.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#608BE4",
  fillRule: "nonzero",
  cx: 2819.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#608BE4",
  fillRule: "nonzero",
  cx: 3349.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F0CBD6",
  fillRule: "nonzero",
  cx: 2466.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F0CBD6",
  fillRule: "nonzero",
  cx: 2987.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F0CBD6",
  fillRule: "nonzero",
  cx: 3517.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#489F9D",
  fillRule: "nonzero",
  cx: 1672.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M1636.227 549.681c4.905-1.142 9.79-1.208 14.755-.43 4.31.675 8.534 1.817 12.862 2.388 7.962 1.05 15.738-.05 22.137-5.152 3.643-2.907 7-6.525 9.96-10.1.184-.222-.104-.522-.321-.32-3.907 3.6-7.147 7.908-11.536 10.985-4.574 3.209-9.949 4.443-15.495 4.319-5.488-.124-10.767-1.563-16.142-2.497-5.485-.952-10.93-1.099-16.316.455-.229.067-.133.407.096.352zM1629.279 578.97c4.797-3.538 10.494-5.989 16.433-6.778 6.46-.858 12.75.695 19.045 1.928 5.462 1.07 11.139 1.673 16.63.428 5.347-1.214 9.667-4.353 13.47-8.157 5.159-5.157 10.32-10.488 15.083-16.005.188-.218-.107-.523-.32-.319-4.813 4.603-9.257 9.61-13.86 14.415-3.983 4.155-8.326 7.874-14.06 9.308-12.151 3.042-23.857-3.847-36.025-2.2a34.265 34.265 0 00-16.616 7.092c-.165.13.052.41.22.287zM1639.279 600.971c4.696-3.292 10.183-5.586 15.915-6.338 6.245-.82 12.34.602 18.425 1.804 5.206 1.03 10.555 1.683 15.832.767 5.189-.903 9.571-3.533 13.355-7.057 2.265-2.11 4.362-4.398 6.497-6.635 2.564-2.687 5.206-5.329 7.637-8.132.187-.215-.106-.515-.32-.314-4.419 4.172-8.427 8.76-12.715 13.062-3.98 3.993-8.454 7.243-14.14 8.352-11.726 2.288-22.934-4.022-34.651-2.438a34.312 34.312 0 00-16.057 6.646c-.16.125.052.402.222.283z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1656.97 613.724c-2.917-3.972-5.079-8.507-6.192-13.32-1.253-5.412-.8-10.826.245-16.235 1.766-9.134 4.326-19.313-.724-27.921-2.492-4.247-6.177-8.033-9.917-11.19-.22-.183-.515.104-.316.318 3.139 3.343 6.54 6.407 9.066 10.285 2.833 4.353 3.662 9.555 3.449 14.68-.214 5.157-1.564 10.128-2.447 15.187-.843 4.845-1.1 9.736-.037 14.566 1.108 5.042 3.36 9.836 6.593 13.85.123.158.402-.054.28-.22zM1686.912 613.662c-10.1-6.015-14.865-18.31-13.88-29.695.57-6.6 2.76-12.943 3.128-19.572.337-6.023-.818-11.966-4.332-16.962-1.832-2.603-4.098-4.85-6.408-7.023-2.981-2.805-5.925-5.684-9.033-8.35-.219-.187-.524.106-.32.32 4.589 4.747 9.97 8.845 14.114 14.008 4.395 5.47 5.78 12.09 5.248 18.986-.513 6.635-2.725 13.01-3.108 19.66-.337 5.803.775 11.694 3.344 16.917 2.442 4.964 6.172 9.347 11.06 12.025.207.112.389-.196.187-.314zM1705.946 601.69c-7.36-7.488-10.628-17.944-9.24-28.205 1.34-9.881 5.211-19.848 1.133-29.646-1.94-4.662-5.57-8.575-9.449-11.78-.22-.184-.528.102-.322.317 3.375 3.518 6.925 6.76 8.94 11.282 2.173 4.87 2.316 10.365 1.653 15.573-.662 5.216-2.201 10.284-2.753 15.518-.517 4.902-.012 9.77 1.635 14.428 1.69 4.785 4.389 9.281 8.139 12.773.177.157.43-.092.264-.26z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2097 598.117s19.273-35.554 31.525-31.846c12.255 3.708 9.238 35.678 9.238 35.678s13.35-19.78 19.452-17.838c6.102 1.943 2.993 22.889 2.993 22.889M2618 598.117s19.273-35.554 31.525-31.846c12.255 3.708 9.238 35.678 9.238 35.678s13.35-19.78 19.452-17.838c6.102 1.943 2.993 22.889 2.993 22.889M3128 598.117s19.273-35.554 31.525-31.846c12.255 3.708 9.238 35.678 9.238 35.678s13.35-19.78 19.452-17.838c6.102 1.943 2.993 22.889 2.993 22.889M2141.032 530s-4.538 27.744 5.416 33.995c9.954 6.252 27.552-4.115 27.552-4.115M2662.032 530s-4.538 27.744 5.416 33.995c9.954 6.252 27.552-4.115 27.552-4.115M3172.032 530s-4.538 27.744 5.416 33.995c9.954 6.252 27.552-4.115 27.552-4.115M2127 530s.423 29.215-38 34M2648 530s.423 29.215-38 34M3158 530s.423 29.215-38 34M2110 610.329s22.502-51.573 17.188 5.671M2631 610.329s22.502-51.573 17.188 5.671M3141 610.329s22.502-51.573 17.188 5.671M2154.634 536s-4.867 25.415 12.366 10.081M2675.634 536s-4.867 25.415 12.366 10.081M3185.634 536s-4.867 25.415 12.366 10.081",
  stroke: "#FFF",
  strokeWidth: 1.152
}), /*#__PURE__*/React.createElement("path", {
  d: "M1319.253 619c0-.737-5.041-15.625 10.184-38.893 10.15-15.513 8.527-28.23-4.872-38.15-7.511-5.094-8.577-9.414-3.197-12.957M469.253 619c0-.737-5.041-15.625 10.184-38.893 10.15-15.513 8.527-28.23-4.872-38.15-7.511-5.094-8.577-9.414-3.197-12.957M814.253 619c0-.737-5.041-15.625 10.184-38.893 10.15-15.513 8.527-28.23-4.872-38.15-7.511-5.094-8.577-9.414-3.197-12.957M1366.077 523c1.23 15.303 1.23 26.02 0 32.15-3.204 15.97-12.077 25.706-17.08 32.647-5.869 8.143-5.275 16.544 1.782 25.203M516.077 523c1.23 15.303 1.23 26.02 0 32.15-3.204 15.97-12.077 25.706-17.08 32.647-5.869 8.143-5.275 16.544 1.782 25.203M861.077 523c1.23 15.303 1.23 26.02 0 32.15-3.204 15.97-12.077 25.706-17.08 32.647-5.869 8.143-5.275 16.544 1.782 25.203",
  stroke: "#FFFDFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1288 591c7.967 7.798 15.443 13.24 22.426 16.326 9.32 4.12 26.276 4.93 36.574 9.674M438 591c7.967 7.798 15.443 13.24 22.426 16.326 9.32 4.12 26.276 4.93 36.574 9.674M783 591c7.967 7.798 15.443 13.24 22.426 16.326 9.32 4.12 26.276 4.93 36.574 9.674M1288 541.791c9.05-1.275 20.69 2.465 34.917 11.223 14.228 8.757 32.59 3.086 55.083-17.014M438 541.791c9.05-1.275 20.69 2.465 34.917 11.223C487.145 561.77 505.507 556.1 528 536M783 541.791c9.05-1.275 20.69 2.465 34.917 11.223C832.145 561.77 850.507 556.1 873 536M1293.368 523c13.083 30.59 11.294 54.924-5.368 73M443.368 523c13.083 30.59 11.294 54.924-5.368 73M788.368 523c13.083 30.59 11.294 54.924-5.368 73",
  stroke: "#FFFDFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1288 571.293c9.17-.91 19.501 2.187 30.994 9.293 17.24 10.66 38.149.929 59.006-17.586M438 571.293c9.17-.91 19.501 2.187 30.994 9.293 17.24 10.66 38.149.929 59.006-17.586M783 571.293c9.17-.91 19.501 2.187 30.994 9.293 17.24 10.66 38.149.929 59.006-17.586",
  stroke: "#FFFDFC"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFFDFC",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2449 566.493l-5 6M2449 601.493l-4 6M2460 565.493l6.5-4.993M2478 543l5 6M2451 538.493l4.583 7.556M2486 571l2.5-7.5M2505 579.493l4 6M2497 623.493l6 8M2506 567.493l4-4M2466 583l5.5-5.5M2501 554.493l-1-6M2445 587l6 2M2521 517.493l4 5M2465 627.493l-4-8M2515 619.49l-4-8.997M2490 530.493l2-6M2449 527.493l4-7M2466 510.493l2 7M2438 516.493l.5 8.55M2508 530.493l3-5M2531 533.565l-7 .857M2514 548.493l4-5M2519 605.493l-4-5M2531 587.493l-4-5M2500 600.493l-5 3M2534 600.493l-5 3M2484 623.493l4-6M2525 622.606l3 4.774M2532 569.493l-6-4M2470 615.493l3-8M2450 618.493l-5 4M2471 596.493l-6 2M2533 550.648l-7 2.845M2488 587.493l9.5-2.993M2434 557l.5-7.5M2428.5 596.5l3.5-8.5M2423 511.493l5 2M2411 521.493l-5 6M2422 530.493l4 5M2416.6 596.049l-3.6-7.556M2420 615.493l-6 4M2413 553.493l-4 6M2417 573.49l5-2.997"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFFDFC",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2970 566.493l-5 6M2970 601.493l-4 6M2981 565.493l6.5-4.993M2999 543l5 6M2972 538.493l4.583 7.556M3007 571l2.5-7.5M3026 579.493l4 6M3018 623.493l6 8M3027 567.493l4-4M2987 583l5.5-5.5M3022 554.493l-1-6M2966 587l6 2M3042 517.493l4 5M2986 627.493l-4-8M3036 619.49l-4-8.997M3011 530.493l2-6M2970 527.493l4-7M2987 510.493l2 7M2959 516.493l.5 8.55M3029 530.493l3-5M3052 533.565l-7 .857M3035 548.493l4-5M3040 605.493l-4-5M3052 587.493l-4-5M3021 600.493l-5 3M3055 600.493l-5 3M3005 623.493l4-6M3046 622.606l3 4.774M3053 569.493l-6-4M2991 615.493l3-8M2971 618.493l-5 4M2992 596.493l-6 2M3054 550.648l-7 2.845M3009 587.493l9.5-2.993M2955 557l.5-7.5M2949.5 596.5l3.5-8.5M2944 511.493l5 2M2932 521.493l-5 6M2943 530.493l4 5M2937.6 596.049l-3.6-7.556M2941 615.493l-6 4M2934 553.493l-4 6M2938 573.49l5-2.997"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFFDFC",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3500 566.493l-5 6M3500 601.493l-4 6M3511 565.493l6.5-4.993M3529 543l5 6M3502 538.493l4.583 7.556M3537 571l2.5-7.5M3556 579.493l4 6M3548 623.493l6 8M3557 567.493l4-4M3517 583l5.5-5.5M3552 554.493l-1-6M3496 587l6 2M3572 517.493l4 5M3516 627.493l-4-8M3566 619.49l-4-8.997M3541 530.493l2-6M3500 527.493l4-7M3517 510.493l2 7M3489 516.493l.5 8.55M3559 530.493l3-5M3582 533.565l-7 .857M3565 548.493l4-5M3570 605.493l-4-5M3582 587.493l-4-5M3551 600.493l-5 3M3585 600.493l-5 3M3535 623.493l4-6M3576 622.606l3 4.774M3583 569.493l-6-4M3521 615.493l3-8M3501 618.493l-5 4M3522 596.493l-6 2M3584 550.648l-7 2.845M3539 587.493l9.5-2.993M3485 557l.5-7.5M3479.5 596.5l3.5-8.5M3474 511.493l5 2M3462 521.493l-5 6M3473 530.493l4 5M3467.6 596.049l-3.6-7.556M3471 615.493l-6 4M3464 553.493l-4 6M3468 573.49l5-2.997"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M151.946 489.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.946 483.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.946 496.214a3.254 3.254 0 01-3.079-4.291 3.245 3.245 0 014.118-2.036 3.254 3.254 0 012.04 4.118 3.251 3.251 0 01-3.08 2.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.946 490.146a2.823 2.823 0 012.67 3.721 2.813 2.813 0 01-3.569 1.766 2.823 2.823 0 01-1.768-3.572 2.814 2.814 0 012.667-1.915m0-.864a3.68 3.68 0 00-1.178 7.168 3.674 3.674 0 004.665-2.306 3.68 3.68 0 00-2.31-4.666 3.66 3.66 0 00-1.177-.196z",
  fill: "#170C2C"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#170C2C",
  strokeWidth: 0.864,
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M69 654l-9 7"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F0CBD6",
  fillRule: "nonzero",
  cx: -22.5,
  cy: 573.5,
  r: 43.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.077 523c1.23 15.303 1.23 26.02 0 32.15C7.873 571.12-1 580.856-6.003 587.797c-5.869 8.143-5.275 16.544 1.782 25.203",
  stroke: "#FFFDFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-67 541.791c9.05-1.275 20.69 2.465 34.917 11.223C-17.855 561.77.507 556.1 23 536M-67 571.293c9.17-.91 19.501 2.187 30.994 9.293 17.24 10.66 38.149.929 59.006-17.586",
  stroke: "#FFFDFC"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F9DC93",
  fillRule: "nonzero",
  cx: 3677.5,
  cy: 573.5,
  r: 43.5
}));

function SvgAboutCertifiedIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3656,
    height: 1145,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/about-certified-illustration.b25d4c86.svg";
export { SvgAboutCertifiedIllustration as ReactComponent };